import React from 'react';

const ParallelProcessingIcon = () => {
  return (
    <svg className="processing-diagram" viewBox="0 0 240 180" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="cpu-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#425b76" />
          <stop offset="100%" stopColor="#2d3e50" />
        </linearGradient>
      </defs>
      
      {/* Background grid representing processing matrix */}
      <g opacity="0.2">
        <line x1="30" y1="30" x2="30" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="60" y1="30" x2="60" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="90" y1="30" x2="90" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="120" y1="30" x2="120" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="150" y1="30" x2="150" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="180" y1="30" x2="180" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="210" y1="30" x2="210" y2="150" stroke="#a0b4c8" strokeWidth="1" />
        
        <line x1="30" y1="30" x2="210" y2="30" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="30" y1="60" x2="210" y2="60" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="30" y1="90" x2="210" y2="90" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="30" y1="120" x2="210" y2="120" stroke="#a0b4c8" strokeWidth="1" />
        <line x1="30" y1="150" x2="210" y2="150" stroke="#a0b4c8" strokeWidth="1" />
      </g>
      
      {/* CPU/Processing Units */}
      <g>
        {/* First row of processors */}
        <rect x="45" y="45" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
        <rect x="105" y="45" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
        <rect x="165" y="45" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
        
        {/* Second row of processors */}
        <rect x="45" y="105" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
        <rect x="105" y="105" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
        <rect x="165" y="105" width="30" height="30" rx="2" fill="url(#cpu-gradient)" />
      </g>
      
      {/* Processing activity indicators */}
      <g>
        <rect x="49" y="49" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.5s" repeatCount="indefinite" />
        </rect>
        <rect x="49" y="59" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3s" repeatCount="indefinite" />
        </rect>
        <rect x="49" y="69" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2s" repeatCount="indefinite" />
        </rect>
        
        <rect x="109" y="49" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.2s" repeatCount="indefinite" />
        </rect>
        <rect x="109" y="59" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3.2s" repeatCount="indefinite" />
        </rect>
        <rect x="109" y="69" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.7s" repeatCount="indefinite" />
        </rect>
        
        <rect x="169" y="49" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.8s" repeatCount="indefinite" />
        </rect>
        <rect x="169" y="59" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3.5s" repeatCount="indefinite" />
        </rect>
        <rect x="169" y="69" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.3s" repeatCount="indefinite" />
        </rect>
        
        <rect x="49" y="109" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3.3s" repeatCount="indefinite" />
        </rect>
        <rect x="49" y="119" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.7s" repeatCount="indefinite" />
        </rect>
        <rect x="49" y="129" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.1s" repeatCount="indefinite" />
        </rect>
        
        <rect x="109" y="109" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.9s" repeatCount="indefinite" />
        </rect>
        <rect x="109" y="119" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3.1s" repeatCount="indefinite" />
        </rect>
        <rect x="109" y="129" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.4s" repeatCount="indefinite" />
        </rect>
        
        <rect x="169" y="109" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.6s" repeatCount="indefinite" />
        </rect>
        <rect x="169" y="119" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="3.4s" repeatCount="indefinite" />
        </rect>
        <rect x="169" y="129" width="22" height="6" rx="1" fill="#a0b4c8" opacity="0.6">
          <animate attributeName="width" values="5;22;5" dur="2.2s" repeatCount="indefinite" />
        </rect>
      </g>
      
      {/* Connecting data flows */}
      <g>
        <line x1="75" y1="60" x2="105" y2="60" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        <line x1="135" y1="60" x2="165" y2="60" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        
        <line x1="75" y1="120" x2="105" y2="120" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        <line x1="135" y1="120" x2="165" y2="120" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        
        <line x1="60" y1="75" x2="60" y2="105" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        <line x1="120" y1="75" x2="120" y2="105" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
        <line x1="180" y1="75" x2="180" y2="105" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="3,2">
          <animate attributeName="stroke-dashoffset" from="15" to="0" dur="2s" repeatCount="indefinite" />
        </line>
      </g>
      
      {/* Labels */}
      <text x="120" y="170" textAnchor="middle" fill="#a0b4c8" fontSize="12" fontWeight="bold">MASSIVELY PARALLEL</text>
    </svg>
  );
};

export default ParallelProcessingIcon;